import { render, staticRenderFns } from "./home-app.vue?vue&type=template&id=b84b237a&scoped=true&"
import script from "./home-app.vue?vue&type=script&lang=js&"
export * from "./home-app.vue?vue&type=script&lang=js&"
import style0 from "./home-app.vue?vue&type=style&index=0&id=b84b237a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84b237a",
  null
  
)

export default component.exports